import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
//import Button from '@mui/material/Button'
//import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
//import NavigateNextIcon from '@mui/icons-material/NavigateNext'

const CustomPagination = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  loadedCount,
}) => {
  //const totalPages = rowsPerPage === -1 ? 1 : Math.ceil(count / rowsPerPage)
  /*const currentPage = page + 1

  const handleNext = () => {
    if (page < totalPages - 1) {
      onPageChange(null, page + 1)
    }
  }

  const handleBack = () => {
    if (page > 0) {
      onPageChange(null, page - 1)
    }
  }*/

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ px: 2, py: 1 }}>
      <Typography variant='body2' sx={{ color: 'text.secondary', fontWeight: 500 }}>
        {rowsPerPage === -1
          ? `1 - ${loadedCount || count} de ${count}`
          : `${page * rowsPerPage + 1} - ${loadedCount || Math.min(count, (page + 1) * rowsPerPage)} de ${count}`}
      </Typography>

      {/*<Stack direction='row' spacing={1} alignItems='center'>
        <Typography variant="caption" sx={{ color: 'text.disabled', mr: 2 }}>
          Página {currentPage} de {Math.max(1, totalPages)}
        </Typography>

        <Button
          onClick={handleBack}
          disabled={page === 0 || rowsPerPage === -1}
          variant="outlined"
          size="small"
          startIcon={<NavigateBeforeIcon />}
          sx={{ borderRadius: '20px', textTransform: 'none', px: 2 }}
        >
          Anterior
        </Button>

        <Button
          onClick={handleNext}
          disabled={page >= totalPages - 1 || rowsPerPage === -1}
          variant="contained"
          size="small"
          endIcon={<NavigateNextIcon />}
          sx={{ borderRadius: '20px', textTransform: 'none', px: 2, bgcolor: 'primary.main' }}
        >
          Siguiente
        </Button>
      </Stack>*/}
    </Stack>
  )
}

export default CustomPagination
export { CustomPagination }
